<template>
  <div class="cycle-error-detail" data-testid="cycle-error-detail">
    <!-- Error indicator dot — click to open detail dialog -->
    <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
          class="cycle-error-detail__dot"
          data-testid="cycle-error-detail__dot"
          @click.stop="showDialog = true"
        >
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7.5" cy="7.5" r="6.25" fill="currentColor"/>
          </svg>
        </span>
      </template>
      <span>Click to view error details</span>
    </v-tooltip>

    <!-- Error detail dialog -->
    <lb-dialog
      v-model="showDialog"
      heading="Cycle Setup Error"
      width="620"
      content-class="cycle-error-dialog"
      data-testid="cycle-error-detail__dialog"
    >
      <template v-slot:body>
        <div class="cycle-error-detail__content" data-testid="cycle-error-detail__content">
          <pre class="cycle-error-detail__message">{{ errorMessage || 'Cycle setup failed' }}</pre>
        </div>
      </template>
      <template v-slot:actions>
        <base-button secondary label="Close" @click="showDialog = false" data-testid="cycle-error-detail__close-btn" />
      </template>
    </lb-dialog>
  </div>
</template>

<script>
export default {
  name: 'CycleErrorDetail',
  props: {
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showDialog: false,
    };
  },
  beforeDestroy() {
    this.showDialog = false;
  },
};
</script>

<style lang="scss" scoped>
@import './CycleErrorDetail.scss';
</style>

<style lang="scss">
/* Unscoped — dialog renders in a portal outside component DOM */
.cycle-error-dialog {
  .v-card__text {
    padding-bottom: 8px !important;
  }

  .v-card__actions {
    padding-top: 0 !important;
  }
}
</style>
